import { render, staticRenderFns } from "./CustomerUserDetailsPasswordEdit.vue?vue&type=template&id=421b3fda"
import script from "./CustomerUserDetailsPasswordEdit.vue?vue&type=script&lang=js"
export * from "./CustomerUserDetailsPasswordEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports